module.exports = "./img/0ae10f17eac7a843eaf8d428b91c649a.png";